import { Reducer } from '@reduxjs/toolkit';
import { Inventory } from 'lib/documents';
import {
  PaginationState,
  FormattedSection
} from '../questionnaires/paginationSlice';

export const QUESTIONNAIRE_TITLE_24_HR = 'In the last day';
export type PostExecutionCallbacks = {
  onSuccess: () => void;
  onError: (error: Error) => void;
};
export interface QuestionnairePaginationCombinedGeneralProps<
  T extends Inventory
> {
  data: T;
  paginationInitialState: PaginationState;
  invalidItems: string[];
  formatData: (data: T, pageLimit: number) => FormattedSection[];
  validate: () => void | any;
  updateItem: (a: {
    title: string;
    value: number | string | string[] | boolean;
  }) => void | any;
  /**
   * Callback for when the user invokes the form submission action
   */
  submit: (callbacks: PostExecutionCallbacks) => Promise<void | any> | any;
  /**
   * If this is set, when the questionnaire is submitted, `questionnaireName` will be added into the navigation stack as a query parameter
   */
  onSubmitExtraNavigationProps?: { questionnaireName: string };
  onPageChange?: (page: number) => void | any;
  onSectionChange?: (page: number) => void | any;
  onStateChange: (paginationState: PaginationState) => void | any;
  /**
   * The top-most text of the page
   */
  pageTitle: string | ((currentSection: number, currentPage: number) => string);
  patientId: string;
}

export type BaseReducer = {
  invalidItems: string[];
  hasError: boolean;
};

export interface PagedQuestionnaireProps<
  A extends BaseReducer,
  T extends Inventory
> {
  /**
   * The key to use when restoring the questionnare state across reloads
   */
  storageKey: string;
  reducer: Reducer<A, any>;
  initialState: A;
  getData: (state: A) => T;
  actions: Pick<
    QuestionnairePaginationCombinedGeneralProps<T>,
    'formatData' | 'updateItem' | 'submit' | 'validate'
  >;
}
